import OrdersAPI from '../../../api/orders';
import types from '../../mutation-types';

export const actions = {
  get: async ({ commit }, params) => {
    commit(types.SET_ORDERS_UI_FLAG, { isFetching: true });
    try {
      const {
        data: { data, meta },
      } = await OrdersAPI.get(params);

      commit(types.CLEAR_ORDERS);
      commit(types.SET_ORDERS, data);
      commit(types.SET_ORDERS_META, meta);
      commit(types.SET_ORDERS_UI_FLAG, { isFetching: false });
    } catch (error) {
      console.error(error);
      commit(types.SET_ORDERS_UI_FLAG, { isFetching: false });
    }
  },

  getPelanggan: async ({ commit }, params) => {
    commit(types.SET_ORDERS_UI_FLAG, { isFetchingPelanggan: true });
    try {
      const {
        data: { data, meta },
      } = await OrdersAPI.getPelanggan(params);

      commit(types.SET_CUSTOMERS_LIST, data);
      commit(types.SET_CUSTOMERS_LIST_META, meta);
      commit(types.SET_ORDERS_UI_FLAG, { isFetchingPelanggan: false });
    } catch (error) {
      console.error(error);
      commit(types.SET_ORDERS_UI_FLAG, { isFetchingPelanggan: false });
    }
  },
  
  getPaketLangganan: async ({ commit }, params) => {
    try {
      const {
        data: { data},
      } = await OrdersAPI.getPaket(params);

      commit(types.SET_PACKAGES_LIST, data);  
    } catch (error) {
      console.error(error);
    }
  },

  getAllCustomerId: async ({ commit }, params) => {
    try {
      const {
        data: { data},
      } = await OrdersAPI.getPelanggan(params);

      return data;
    } catch (error) {
      console.error(error);
    }
  },
};
